import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wd-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.css']
})
export class PageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
